import { gql } from '@apollo/client';

export const GET_PRODUCTS = gql`
  query listProducts {
    listProducts {
      id
      name
      productTypeId
      brandId
      hotsite
      appURL
      TOSLink
      category
      compatibility
      lastUpdated
      version
    }
  }
`;

export const GET_PRODUCT_BY_ID = gql`
  query product($id: String!) {
    product(id: $id) {
      id
      name
      hotsite
      appURL
      TOSLink
      category
      compatibility
      lastUpdated
      version
    }
  }
`;

export const GET_PRODUCTS_BY_BRAND = gql`
  query listProductsByBrand($brandId: String!) {
    listProductsByBrand(brandId: $brandId) {
      id
      name
    }
  }
`;

export const ADD_PRODUCT = gql`
  mutation createProduct(
    $name: String!
    $productTypeId: String!
    $brandId: String!
    $hotsite: String
    $appURL: String
    $TOSLink: String
    $category: String
    $compatibility: String
    $lastUpdated: String
    $version: String
  ) {
    createProduct(
      input: {
        name: $name
        productTypeId: $productTypeId
        brandId: $brandId
        hotsite: $hotsite
        appURL: $appURL
        TOSLink: $TOSLink
        category: $category
        compatibility: $compatibility
        lastUpdated: $lastUpdated
        version: $version
      }
    ) {
      id
      name
      productTypeId
      brandId
      hotsite
      appURL
      TOSLink
      category
      compatibility
      lastUpdated
      version
    }
  }
`;

export const EDIT_PRODUCT = gql`
  mutation updateProduct(
    $id: String!
    $name: String!
    $productTypeId: String!
    $brandId: String!
    $hotsite: String
    $appURL: String
    $TOSLink: String
    $category: String
    $compatibility: String
    $lastUpdated: String
    $version: String
  ) {
    updateProduct(
      id: $id
      input: {
        name: $name
        productTypeId: $productTypeId
        brandId: $brandId
        hotsite: $hotsite
        appURL: $appURL
        TOSLink: $TOSLink
        category: $category
        compatibility: $compatibility
        lastUpdated: $lastUpdated
        version: $version
      }
    ) {
      id
      name
      productTypeId
      brandId
      hotsite
      appURL
      TOSLink
      category
      compatibility
      lastUpdated
      version
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation deleteProduct($id: String!) {
    deleteProduct(id: $id) {
      id
      name
    }
  }
`;
